import axios from "../config"

class UserAccountService{
    axios;
    constructor(){
        this.axios = axios;
    }
    getUserAccountDtoBySearch(search) {
      let url = `/userAccounts/tensearch`
      return axios.get(url,{
          params:{
            search
          }
      }).then(request => request.data);
    }
    getUserAccounts(userType) {
        let url = `/useraccounts`
        return axios.get(url,{
            params:{
                userType
            }
        }).then(request => request.data);
      }
      getUi(userType) {
        let url = `/ui`;
        return this.axios.get(url,{params:{
          userType
        }}).then(request => request.data);
      }
      updateUi(uiAccept) {
        let url = `/ui`;
        return this.axios.put(url,uiAccept).then(request => request.data);
      }
      getUiByUserId() {
        let url = `/ui/userId`;
        return this.axios.get(url).then(request => request.data);
      }
      getUserAccountsProfile(userType,page) {
        let url = `/useraccounts/profile`
        return axios.get(url,{
            params:{
                userType,page
            }
        }).then(request => request.data);
      }
      getUserAccountsByPatientId(patientId){
        let url = `/useraccounts/patient/${patientId}`
        return axios.get(url).then(request => request.data);
      }
      getUserAccountsDetail(userAccountId) {
        let url = `/useraccounts/detail/${userAccountId}`
        return axios.get(url).then(request => request.data);
      }
      addUserAccounts(useraccounts) {
        let url = `/useraccounts`;
        return this.axios.post(url, useraccounts).then(request => request.data);
      }
      deleteUser(user) {
        let url = `/useraccounts/${user.userAccountId}`;
        return this.axios.delete(url).then(request => request.data);
      }
      updateUserAccounts(user) {
        let url = `/useraccounts/${user.userAccountId}`;
        return this.axios.put(url, user).then(request => request.data);
      }
      getDutyTime(userAccountId) {
        let url = `/useraccounts/${userAccountId}/dutytime`
        return axios.get(url).then(request => request.data);
      }
      updateDutyTime(dutyTime) {
        let url = `/useraccounts/dutytime`;
        return this.axios.put(url, dutyTime).then(request => request.data);
      }
      updateUserPhoto(formData,user){
        let url = `/useraccounts/pictures/${user.userAccountId}`;
        return axios.put(url, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(request => request.data);
    }
    changePassword(currentPassword, newPassword) {
      let url = `userAccounts/changepassword`
      return this.axios.get(url,
        {
          params: {
            currentPassword,
            newPassword
          }
        }).then(request => request.data);
    }
    getDateOfBirth(dateofbirth) {
      let url = `/userAccounts/dateofbirth`
      return axios.get(url,{
        params:{
          dateofbirth
        }
      }).then(request => request.data);
    }
    getUserSearch(search,userId) {
      let url = `/userAccounts/search`
      return axios.get(url,{
          params:{
            search,userId
          }
      }).then(request => request.data);
    }
    getUserCount(){
      let url = `/useraccounts/count`
      return axios.get(url,{
      }).then(request => request.data);
    }
    getUserOwnByBarCode(encryUserId) {
      let url = `/userAccounts/barcode`
      return axios.get(url,{
          params:{
            encryUserId
          }
      }).then(request => request.data);
    }
    getSaleByPatientId(userAccountId) {
      let url = `/sale/patient/${userAccountId}`
      return axios.get(url).then(request => request.data);
    }
    onesignalAccount(){
      let url = `/onesignalAccount`
      return axios.get(url).then(request => request.data);
    }
}

const service = new UserAccountService();
export default service;